export const checkName = (name) => {

    return !name?.includes("~")
}
export const checkSize = (size, maxSize = 2) => {

    const defaultSize = Math.pow(1024, 2)

    return size < defaultSize * maxSize
}